<template>
    <div class="product-item">
        <div class="product-item-image">
            <a :href="p_item.url">
                <img v-if="!adult_flag && item_adult && !is_checked_adult" :src="common_img" />
                <img v-else :src="p_item.img"  />
                <img src="/images/icons/caution.png" alt="注意" class="caution-icon" v-if="p_item.is_caution" />
            </a>
            <span v-if="status_flag" class="product-item-status" :class="p_item.status_class">{{ p_item.status_text }}</span>
            <span v-if="p_item.item_delivery_type.includes('送料込み')" class="product-item-delivery badge bg-light">送料込み</span>
          <span v-if="sold_flag" class="product-item-sold-out">SOLD OUT</span>
        </div>
        <div class="product-item-info">
            <h2 class="title">
                <a :href="p_item.url">{{ p_item.title }}</a>
            </h2>
            <div class="custom-item-adult">
              <p v-if="item_adult" class="product-item-adult badge badge-danger mb-0">成人向け</p>
            </div>

            <p class="price">{{ p_item.price}}<span class="price-status">（税込）</span></p>

            <p class="seller">
                <a :href="p_item.user_url">
                    <img :src="p_item.seller_img" />{{ p_item.seller_name }}
                </a>

            </p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['item'],
        data() {
            return {
                common_img: '/images/icons/adult.PNG',
                p_item: this.item,
                status_flag: this.item.status_text ? true : false,
                sold_flag: this.item.order_items_length > 0 ? true : false,
                adult_flag: this.item.user_adult,
                item_adult: this.item.is_item_adult,
                is_checked_adult: localStorage.getItem('isAdult')
            }
        },
    }
</script>

<style lang="scss" scoped>
    .product-item {
        width:180px;
        /*height: 300px;*/
        border: 1px solid #E3E3E3;
        border-radius: 3px;
        margin-right: 15px;
        float: left;
        &.adult {
            background: #f9d7e5;
        }
    }

    .product-item-image {
        height: 178px;
        width: 178px;
        position: relative;
        background-color: #E3E3E3;
    }


    @media (max-width: 768px) {
        .product-item {
            width: calc(50% - 4px);
            display: inline-block;
            margin-bottom: 15px;
            /*height: 290px;*/
        }

        .product-item-image {
            width: 100%;
            height: 160px;
        }

        .product-items-container .product-item:nth-child(even) {
            margin-right: 0;
        }

        .product-items-container .product-item:nth-child(odd) {
            margin-right: 8px;
        }
    }

    .product-item-image:hover {
        opacity: 0.5;
    }

    .product-item-image img {
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        //width: 100%;
        //height: 100%;
        //object-fit: cover;
        //object-position: center;
        max-width: 100%;
        height: auto;
        max-height: 100%;
        &.adult {
            filter: blur(8px); 
        }
    }

    .product-item-info {
        padding: 8px 8px 6px 8px;
    }

    .product-item-info h2 {
        font-size: 16px !important;
        line-height: 19px;
        height: 38px;
        margin-bottom: 0;
        line-height: 1.5;
    }

    .product-item-info p.price {
        text-align: right;
        font-size: 18px;
        line-height: 24px;
        font-weight: bold;
        margin-top: 10px;
        margin-bottom: 6px;
    }

    .product-item-info p.price span.price-status{
        font-size: 14px;
    }


    .product-item-info a, .product-item-info a:hover, .product-item-info a:visited {
        color: #000;
    }

    .product-item-info a {
        text-decoration: none;
    }

    .product-item-info a:hover {
        text-decoration: underline;
    }

    .product-item-info .seller {
        font-size: 12px;
        margin-bottom: 0;
    }

    .product-item-info .seller img {
        width: 20px;
        height: 20px;
        border-radius: 10px;
        margin-right: 8px;
    }

    .product-item-info .seller a, .product-item-info .seller a:visited {
        color: #939393; text-decoration: underline;
    }

    .product-item-info .seller a:hover {
        color: #939393; text-decoration: none;
    }

    .product-item-status {
        position: absolute;
        left: 9px; top: 9px;
        text-align: center;
    }

    .product-item-delivery {
        position: absolute;
        right: 19px; top: 9px;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
    }

    .new-item-status {
        color: #fff;
        font-size: 13px;
        line-height: 20px;
        background-color: #F5485E;
        width: 44px;
        border-radius: 24px;
    }

    .product-item-sold-out {
        color: #fff;
        font-size: 13px;
        line-height: 20px;
        background-color: #9f1d1d;
        width: 80px;
        text-align: center;
        border-radius: 0;
        position: absolute;
        right: 0;
        bottom: 0;
    }

    .sale-status-first {
        font-size: 14px;
        line-height: 24px;
        width: 23px;
        color: #fff;
        background-color: #F2C21D;
    }

    .sale-status-second {
        font-size: 14px;
        line-height: 24px;
        width: 23px;
        color: #fff;
        background-color: #D0D0D0;
    }

    .sale-status-third {
        font-size: 14px;
        line-height: 24px;
        width: 23px;
        color: #fff;
        background-color: #C09262;
    }

    .sale-status-other {
        font-size: 14px;
        line-height: 24px;
        width: 23px;
        color: #fff;
        background-color: #969696;
    }

    .caution-icon {
      width: 42px;
      top: 85% !important;
      left: 85% !important;
    }

    @media (max-width: 768px) {
        .sale-status-first, .sale-status-second, .sale-status-third, .sale-status-other
        {
            left: 0; top: 0;
        }
    }
</style>